import { useMutation, useQueryClient } from '@tanstack/react-query';
import { voicesApi } from '../services/voicesApi';
import type { VoiceResponse } from '@troia-v3/types';
import { toast } from 'sonner';

export const useCreateVoice = () => {
  const queryClient = useQueryClient();

  return useMutation<VoiceResponse, Error, FormData>({
    mutationFn: (formData) => voicesApi.create(formData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['voices'] });
      queryClient.invalidateQueries({ queryKey: ['voices-dropdown'] });
      toast.success('Voz criada com sucesso!');
    },
    onError: (error) => {
      toast.error(`Erro ao criar voz: ${error.message}`);
    },
  });
};
